module.exports = __webpack_public_path__ + "img/7.5f915ca7.svg";